/*
 * @fileOverView table component definition
 */

import Vue from 'vue';
import Throttle from 'utils/Throttle';
import {Events, Intervals} from 'utils/Constants';

/**
 * A reference to the classes used in this view
 *
 * @property CLASSES
 * @type {Object}
 * @private
 */
const CLASSES = {
  'WRAPPER_SCROLLABLE_LEFT': 'tableWrapper_scrollableLeft',
  'WRAPPER_SCROLLABLE_RIGHT': 'tableWrapper_scrollableRight'
};

/**
 * [Table Vue]
 * @type {class}
 */
Vue.component('table-vue', {

  methods: {
    /**
     * [updateTableScroll handles adding and removing the shadow on the sides of the table indicated there is more]
     * @param  {jquery element} $scrollerTarget [the $scrollerTarget]
     * @return {void}
     */
    updateTableScroll($scrollerTarget) {
      const scrollLeft = $scrollerTarget.scrollLeft();
      const $wrapperTarget = $scrollerTarget.parent();
      const $table = $scrollerTarget.children();

      const scrollRight = Math.abs(scrollLeft + $scrollerTarget.width() - $scrollerTarget.get(0).scrollWidth);
      const threshold = 5;

      // Determine if the left side of the table is visible.
      if (scrollLeft > threshold) {
        $wrapperTarget.addClass(CLASSES.WRAPPER_SCROLLABLE_LEFT);
        $table.attr('tabindex', 0);
      }
      else {
        $wrapperTarget.removeClass(CLASSES.WRAPPER_SCROLLABLE_LEFT);
        $table.removeAttr('tabindex');
      }

      // Determine if the right side of the table is visible.
      if (scrollRight > threshold) {
        $wrapperTarget.addClass(CLASSES.WRAPPER_SCROLLABLE_RIGHT);
        $table.attr('tabindex', 0);
      }
      else {
        $wrapperTarget.removeClass(CLASSES.WRAPPER_SCROLLABLE_RIGHT);
        $table.removeAttr('tabindex');
      }
    }
  },

  mounted() {
    this.table = this.$el.querySelector('table');
    this.$scrollerTarget = $(this.table.parentNode);
    const callback = Throttle(() => this.updateTableScroll(this.$scrollerTarget), Intervals.SCROLL_INTERVAL);
    this.$scrollerTarget.on(Events.SCROLL, callback);
    window.addEventListener(Events.RESIZE, callback);
    this.updateTableScroll(this.$scrollerTarget);
  }
});
